document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const addToCartBtn = event.target.closest('.product-slider--add-to-cart-wrapper button');
    if (!addToCartBtn) return;

    event.preventDefault();

    const originalText = addToCartBtn.textContent;
    addToCartBtn.textContent = 'Adding...';
    addToCartBtn.classList.add('adding');

    const slide = addToCartBtn.closest('.mlveda-product-slider--item');
    if (!slide) return;

    const variantSelect = slide.querySelector('.product-slider--variant-select-wrapper select');
    let variantId;

    if (variantSelect) {
      // ✅ Multiple variants – get selected value
      if (!variantSelect.value) {
        alert('Please select a variant before adding to cart.');
        addToCartBtn.textContent = originalText;
        addToCartBtn.classList.remove('adding');
        return;
      }
      variantId = variantSelect.value;
    } else {
      // ✅ Single variant – get it from hidden element
      const defaultVariant = slide.querySelector('[data-single-variant-id]');
      if (!defaultVariant) {
        alert('Variant information missing.');
        addToCartBtn.textContent = originalText;
        addToCartBtn.classList.remove('adding');
        return;
      }
      variantId = defaultVariant.getAttribute('data-single-variant-id');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(res => res.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (typeof getCartData === 'function') getCartData();

        addToCartBtn.textContent = 'Thank You!';
        setTimeout(() => {
          addToCartBtn.textContent = originalText;
          addToCartBtn.classList.remove('adding');
        }, 800);
      })
      .catch(err => {
        console.error('Add to cart failed:', err);
        alert('Failed to add item to cart.');
        addToCartBtn.textContent = originalText;
        addToCartBtn.classList.remove('adding');
      });
  });
});
